module.exports = __webpack_public_path__ + "images/23641e5b4c7b2c73a1341e6c4f0df8fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/components/QuoteSidebar/img/cc3.jpg
// module id = 1382
// module chunks = 0